import { useIsAuthenticated } from '@azure/msal-react';
import { Navigate, useLocation } from 'react-router-dom';
import type { ReactNode } from 'react';
import { isAuthConfigured } from './config';
import { rememberReturnTo } from './AuthProvider';

/**
 * Gate for authenticated routes. Remembers where the user was going so sign-in
 * returns them there instead of dumping everyone on the dashboard.
 *
 * When auth is not configured (local dev without an app registration) the gate
 * is inert — otherwise the whole app would be unreachable.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const isAuthenticated = useIsAuthenticated();
  const location = useLocation();

  if (!isAuthConfigured || isAuthenticated) {
    return <>{children}</>;
  }

  rememberReturnTo(location.pathname + location.search);
  return <Navigate to="/signin" replace />;
}
